export default "__VITE_ASSET__BARirQbv__"